
function toggleFaq(el){el.classList.toggle('open')}

(function(){
  // Pixel-Loader (deferred until consent)
  window.evdLoadPixel = function(){
    if (window._evdPixelLoaded) return;
    window._evdPixelLoaded = true;
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '791851207026224');
    // META PIXEL: PageView — fire once per actual page load only
    if (!window.__evdPageViewTracked) {
      window.__evdPageViewTracked = true;
      fbq('track', 'PageView');
    }
  };
  // Auto-load pixel if consent already given (returning visitor)
  try {
    if (localStorage.getItem('evd_consent') === 'granted') {
      window.evdLoadPixel();
    }
  } catch(e) {}
})();


